import {
  BRAND_LIST,
  CountryLanguageSwitcher,
  DistanceUnit,
  Languages,
} from 'typings'

export type ConstantsType = {
  REGION: RegionGroupNames
  CODE: string
  LANGUAGE_CODE: string

  IS_EU: boolean
  EU_COUNTRY_LIST: {
    lid: string
    countryCode: string
    defaultTo?: string
  }[]

  BRAND: string
  COUNTRY: string
  LANGUAGE: string
  BASE_NAME: string

  /** Link for UNIQLO Logo  */
  BASE_URL: string

  GOOGLE_MAPS_API_KEY: string

  LONG_NAME: string
  SHORT_NAME: string
  DISPLAY_NAME: string
  DISPLAY_COUNTRY: string

  LANGUAGES: {
    [country: string]: string
  }

  GEO_COORDINATES: {
    INITIAL_LATITUDE: number
    INITIAL_LONGITUDE: number
    INITIAL_ZOOM: number
    INITIAL_ZOOM_DETAILS_PAGE: number
  }

  AREAS: {
    [areaCode: string]: string
  }

  POSTCODE_FORMAT: RegExp | string

  MAX_DISTANCE: number
  RESULTS_PER_PAGE: number
  AREA_TRANSLATION_KEY: string

  HOME_PAGE_URL: string
  HOME_PAGE_MOBILE_URL?: string

  MAP_URL?: string
  MAP_MOBILE_URL?: string

  TERMS_OF_USE_URL: string
  PRIVACY_POLICY_URL: string

  CONTACT_US_URL: string

  SHOW_TIME_IN_MILITARY: boolean
  DISTANCE_UNIT: DistanceUnit

  CLIENT_ID: {
    [brand: string]: string
  }

  LOGO_SUFFIX: {
    [brand: string]: string
  }

  MARKER_SUFFIX: {
    [brand: string]: string
  }

  CMS_ENABLED: {
    [brand: string]: boolean
  }

  PARKING_FILTER: {
    WHEELCHAIR_ACCESSIBLE_PARKING: {
      [brand: string]: boolean
    }
  }

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [brand: string]: CountryLanguageSwitcher
  }

  AM_FORMAT: string
  PM_FORMAT: string

  ONE_TRUST_FOOTER: {
    [brand: string]: boolean
  }

  DONOT_SELL_PERSONAL_INFO: {
    [brand: string]: string
  }

  SHOW_STORE_SERVICE_FILTER: {
    [brand: string]: boolean
  }
  LANGUAGE_OPTIONS: Record<
    string,
    { lid: string; label: string; locale?: string }
  >
}

export type LocaleType = Partial<ConstantsType> &
  Partial<
    Record<BRAND_LIST, Partial<Record<Languages, Partial<ConstantsType>>>>
  >

export enum RegionGroupNames {
  JAPAN = 'JAPAN',
  ASIA = 'ASIA',
  NORTH_AMERICA = 'NORTH_AMERICA',
  SOUTH_ASIA = 'SOUTH_ASIA',
  SOUTH_EAST_ASIA = 'SOUTH_EAST_ASIA',
  OTHER = 'OTHER', // Europe
}
